module.exports = __webpack_public_path__ + "fonts/triya-icon.f7938c4.woff";